<template>
      <v-card link flat width="75">
        <v-card-text @click="changeLangName" style="padding-left:10px;padding-right:10px;">{{ langName }}</v-card-text>
      </v-card>
</template>

<script>
export default {
  name: 'MpLang',
  data: () => ({}),
  computed: {
    langName () {
      return this.$store.state.isLangJa ? 'English' : '日本語'
    }
  },
  methods: {
    changeLangName () {
      // 表示の言語切替
      this.$i18n.locale = (this.$i18n.locale === 'ja') ? 'en' : 'ja'
      this.$store.dispatch('langChange', this.$i18n.locale)
    }
  }
}
</script>
